module.exports = __webpack_public_path__ + "static/media/_ME11300.baf33f0e.jpg";